export enum CertificateType {
  individual = 0,
  group = 1,
}
